import { render } from "./Testimonial.vue?vue&type=template&id=456da29c&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=456da29c&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456da29c"]])

export default __exports__